import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators, } from '@angular/forms';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-table-sel-papeleria',
  templateUrl: './table-sel-papeleria.component.html',
  styleUrls: ['./table-sel-papeleria.component.scss']
})

export class TableSelPapeleriaComponent implements OnInit {

  private datosTabla: any[] = [];
  private totalRegistros = 0;

  @Input() cols: any[]

  @Output() pagination = new EventEmitter<any>();

  @Input() hasEdit = false;
  @Input() hasDetail = false;
  @Input() hasDelete = false;
  @Input() paginator: boolean;
  @Input() lazy: boolean;
  @Output() onEdit = new EventEmitter<any>();
  @Output() onDetail = new EventEmitter<any>();
  @Output() onDelete = new EventEmitter<any>();
  @Output() filaSeleccionada: EventEmitter<any> = new EventEmitter();
  @Input() styleClass = "p-datatable-papeleria";
  @Input() dataKey = "";
  @Input() idSeleccionado = "";

  selectForm: FormGroup;
  selected: any;
  rows: number = environment.rowsPerPage;
  isNotRowSelected = true;
  first = 0;

  diponibleStatus = "Disponible";
  enUsoStatus = "En Uso";
  noDisponibleStatus = "No Disponible";
  claseDisponible = "disponible";
  claseEnUso = "en-uso";
  claseNoDisponible = "no-disponible'";
  nombreColumna = "estado";
  seleccionTipo = "radio";
  seleccionColumna = "seleccionar";
  tipoPapeleria = "tipoPapeleriaNombre";

  constructor(private formBuilder: FormBuilder,) {
    this.crearFormulario();
  }

  ngOnInit(): void {
    //
  }

  @Input() set dataTable(data: any) {
    if (data) {
      this.datosTabla = data.data;
      this.totalRegistros = data.totalRecords;
      this.isNotRowSelected = true;
      this.selected = null;
      if (data.isFirst) {
        this.first = 0;
      }
    }
  }

  get dataTable(): any { return this.datosTabla; }
  get totalRecords(): any { return this.totalRegistros; }

  paginationEmitter(event): void {
    if (this.totalRecords > 0) {
      this.pagination.emit(event.first / event.rows);
    }
  }

  crearFormulario(): void {
    if(this.seleccionColumna!==""){
      this.selectForm = this.formBuilder.group({
        seleccion: [this.idSeleccionado, [Validators.required]],
      });
    }
  }

  editEmitter(): any {
    this.onEdit.emit(this.selected);
  }
  detailEmitter(): any {
    this.onDetail.emit(this.selected);
  }
  deleteEmitter(): any {
    this.onDelete.emit(this.selected);
  }

  seleccionarFila(rowData: any): void {
    this.filaSeleccionada.emit(rowData);
  }
}
